export default {
  letsPlayBrand: "LET’S PLAY",
  "courtSize": {"single": "Single", "double": "Double"},
  "unfinishedColumn": "Partial",
  "rejectedSave": "Your club could not accept these changes. Your local actions are kept. Review the latest score or download your actions before discarding them.",
  "unverifiedSave": "We could not verify saving. Your local actions are kept. Review the latest score or download your actions before discarding them.",

  "finishQuestion": "Finish session?",
  "saveFinish": "Save & finish",
  "unfinishedOutcome": "Unfinished session",
  "tiedOutcome": "Scores level",
  "finishedOutcome": "Session finished",
  "savingResult": "Saved on this device · Saving to your club…",
  "offlineResult": "Saved on this device · Will sync when connected",
  "syncedResult": "Saved to your club",
  "momentWaiting": "Your moment will open once saving completes…",
  "saveFailed": "Couldn’t sync. Your score is kept on this device.",

  "deleteChanged": "This session changed before it could be deleted. Resume it to review the latest scores, then try deleting again.",
  "moreActions": "More",
  "deleteSession": "Delete session",
  "deleteNote": "Remove this session from Continue playing? Scores and audit history are retained. Court bookings are unchanged.",
  "deletePending": "This session has unsynchronised scores or a local draft. Resume it to sync or review and discard that work before deleting.",
  "deleting": "Deleting…",
  "live": "Live",
  "completedSet": "Completed set",
  "completedGame": "Completed game",
  "sports": "Sports",
  "format": "Format",
  "pointAction": "Point",
  "serviceSetup": "Service setup",
  "finalScores": "Final scores",
  "scoringMode": "Scoring mode",
  "enterScores": "Enter your scores",
  "reviewSave": "Review & save",
  "applyContinue": "Apply scores & continue live",
  "discardContinue": "Discard edits & continue live",
  "changeService": "Change server / service",
  "choose": "Choose…",
  "rallyWon": "Rally won",
  "discardChanges": "Discard changes",
  "error_draft_unreadable": "The stored Final scores draft could not be read. Keep this device’s data and contact support before replacing it.",
  "error_draft_action_required": "Review your Final scores changes, discard them, or keep editing before scoring another way.",
  "error_draft_consent_required": "Review the replacement score and confirm to finish.",
  "error_draft_revision_changed": "Compare your entries with the latest saved score and confirm the comparison below.",
  "error_point_mode_changed": "Confirm the new point controls below before reviewing this score.",
  "error_point_combination_invalid": "Advantage must be paired with 40. For deuce, choose 40 for both players.",
  "keepDraftAndLeave": "Keep changes and leave",
  "discardAndLeave": "Discard changes and leave",
  "keepEditing": "Keep editing",
  "draftLeaveNote": "Your entered scores have not been applied. Keep them to return later, discard them, or continue editing.",
  "unappliedChanges": "Unapplied score changes",
  "reviewAndFinish": "Review score and finish session",
  "cardDraftPreserved": "Unapplied Final scores changes",
  "draftPending": "These reviewed changes are queued. They cannot be applied twice.",
  "draftStorageError": "Your edits are still here, but could not be stored on this device. Keep this screen open and retry.",
  "directHistoryDetails": "This replaces dependent scoring progress, including later play. All previous actions remain in History.",
  "replacementDetails": "What changes?",
  "reconcileDraft": "I have compared my entries with the latest saved score",
  "draftRevisionChanged": "The saved score changed while you were editing. Compare it with your entries below before replacing it.",
  "useOrdinaryPoints": "Use game points · clear current points",
  "useTieBreakPoints": "Use tie-break points · clear current points",
  "pointModeChanged": "The final set changed scoring mode. Choose the point controls explicitly; this will clear the current points.",
  "advantage": "Advantage",
  "loveZero": "Love / 0",
  "serviceUnknown": "Service not recorded",
  "interpreting": "Interpreting…",
  "reopenCorrection": "This correction reopens the session. Review the score and finish the session again to save it.",
  "tieBreakFirstServer": "Who served first in this tie-break?",
  "preparingMatch": "Preparing your match",
  "preparingDetail": "Getting courts and players ready",
  "restoringMatch": "Restoring your match",
  "restoringDetail": "Getting your scorecard ready",
  "setupProgress": "Match setup",
  "member": "Member",
  "session_saved": "Session saved",
  "sessionSaved": "Session saved",
  "sessionPending": "Session awaiting sync",
  "playEnded": "Play ended. No overall winner declared.",
  "finishSession": "Review & save",
  "set": "Set",
  "game": "Game",
  "points": "Points",
  "unfinishedSegment": "In progress · unfinished",
  "segmentCompleted": "Completed",
  "addSet": "Add another set",
  "addGame": "Add another game",
  "currentPointsOptional": "Current points (optional)",
  "directHistoryAck": "Replace the recorded score",
  "directEntryReason": "Reviewed scorecard entry",
  "reviewScore": "Review & save",
  "receivingFirst": "Who receives first on the other team?",
  "rightCourt": "Player on the right · team",
  "startLive": "Continue live scoring",
  "operation_direct_score": "Entered score",
  "operation_configure_service": "Service confirmed",
  "operation_finish_session": "Session finished",
  "error_unfinished_segment_must_be_last": "Only the final segment can be unfinished. Complete it before adding another.",
  "error_mark_segment_completed": "This score completes the segment. Mark it completed, or correct the score.",
  "correctLastRally": "Correct last rally",
  "operation_replace_last_rally": "Last rally corrected",
  "conflictStatus": "Needs review",
  "storageStatus": "Needs review",
  "pendingOnline": "Saving",
  "historyTitle": "Your Let’s Play",
  "historyIntro": "The rounds, games and moments you’ve shared.",
  "all": "All",
  "filterHistory": "Filter history",
  "historyLoad": "Loading your history",
  "historyEmptyTitle": "Your history starts here",
  "historyEmpty": "Completed activities will appear here.",
  "more": "Load more",
  "manageMoment": "Manage moment",
  "photoUnavailable": "Photo unavailable",
  "moment_loadError": "We couldn’t open this activity moment.",
  "moment_imageError": "Choose a JPEG, PNG or WebP image up to 15 MB.",
  "moment_discard": "Discard this photo?",
  "moment_offline": "You’re offline. Your activity is safe — add this moment later from History.",
  "moment_conflict": "This moment changed on another device. Reload before trying again.",
  "moment_saveError": "Your photo wasn’t saved. Keep it here and try again.",
  "moment_captionError": "The caption could not be saved.",
  "moment_removeConfirm": "Remove this moment? The completed activity will not be changed.",
  "moment_removeError": "The moment could not be removed. Reload and try again.",
  "moment_opening": "Opening your moment",
  "moment_access": "Checking activity access",
  "moment_unavailable": "Moment unavailable",
  "moment_label": "ACTIVITY MOMENT",
  "moment_from": "A moment from this activity",
  "moment_none": "No moment was captured",
  "moment_alt": "Activity moment",
  "moment_your": "YOUR MOMENT",
  "moment_activityComplete": "ACTIVITY COMPLETE",
  "moment_remember": "Remember this one",
  "moment_capture": "Capture the moment?",
  "moment_intro": "Great games are worth remembering.",
  "moment_editCaption": "Edit caption",
  "moment_saveCaption": "Save caption",
  "moment_remove": "Remove moment",
  "moment_take": "Take photo",
  "moment_replace": "Replace photo",
  "moment_choose": "Choose photo",
  "moment_later": "Not now",
  "moment_keep": "Keep this one?",
  "moment_preview": "Selected moment preview",
  "moment_caption": "Add a caption (optional)",
  "moment_captionExample": "Summer knockout with Chris",
  "moment_preparing": "Preparing and saving…",
  "moment_save": "Save moment",
  "moment_another": "Choose another",
  "error_invalid_segment_score": "Enter a valid completed set/game score, or mark the last row unfinished. Check each highlighted row.",
  "error_invalid_point_score": "Use 0, 15, 30, 40 or advantage. A finished game needs a game summary.",
  "error_invalid_game_score": "Enter an unfinished set score up to 6–6, or record a completed set.",
  "error_invalid_correction": "Enter both scores and choose the server and service box.",
  "error_service_information_required": "Choose the next server and service box explicitly.",
  "error_invalid_service_box": "The service box does not match this score and server. Check their court position.",
  "error_invalid_service_order": "Check the service order. Tennis and Padel teams must alternate.",
  "error_server_number_required": "Choose server 1 or 2 for doubles, or server 1 for singles.",
  "error_court_positions_required": "Confirm each team’s right-court player before applying.",
  "error_invalid_court_positions": "The selected server is not in the selected service box. Check court positions.",
  "error_terminal_score_requires_segment": "This score ends a game or set. Use a completed segment summary.",
  "error_summary_would_rewrite_games": "The final score cannot erase games already recorded. Correct current games first or review historical segments.",
  "error_dependent_history_requires_resolution": "Confirm that all later segments and current progress will be discarded.",
  "error_queue_capacity_reached": "The device queue is full. Reconnect to save before recording more actions.",
  "error_court_not_available_for_sport": "This court is no longer available for this sport. Choose another court.",
  "error_format_not_supported_by_court": "Choose a format supported by this court or select another court.",
  "error_duplicate_participant": "Each player must appear once. Check teams and guest names.",
  "error_reason_required": "Enter a reason so the correction is clear in match history.",
  "tieBreak": "Tie-break",
  "currentGames": "Current games (resets current points)",
  "operation_correct_games": "Current games summary",
  "court": "Court",
  "match": "Match",
  "players": "Players",
  "review": "Review",
  "where": "Where are we playing?",
  "how": "How are we playing?",
  "who": "Who’s playing?",
  "ready": "Ready to play?",
  "back": "Back",
  "next": "Continue",
  "retry": "Try again",
  "loading": "Loading your match…",
  "error": "We couldn’t complete that request. Check your connection and try again.",
  "noCourts": "No suitable courts are configured. Contact the club to configure a court for this sport.",
  "noReservation": "Starting a scorecard does not reserve a court or charge your account.",
  "indoor": "Indoor",
  "outdoor": "Outdoor",
  "singles": "Singles",
  "doubles": "Doubles",
  "adjust": "Adjust scoring",
  "start": "Start match",
  "starting": "Starting…",
  "edit": "Edit",
  "resumeMatches": "Continue playing",
  "recent": "Recent players",
  "search": "Find a club member",
  "noResults": "No matching members",
  "guest": "Guest name",
  "addGuest": "Add guest",
  "remove": "Remove",
  "move": "Move to other team",
  "team": "Team",
  "youScorer": "You are the scorer. Other participants can view this match.",
  "server": "Server",
  "firstServer": "Who serves first?",
  "order": "Service order",
  "initialBox": "Initial service box",
  "left": "Left",
  "right": "Right",
  "requiredPlayers": "Add the required players and assign equal teams.",
  "saved": "Saved",
  "saving": "Saving",
  "pending": "Offline",
  "conflict": "This match changed on another device. Your pending actions are preserved.",
  "export": "Download pending actions",
  "useServer": "Keep server score and discard pending actions",
  "discardConfirm": "I have reviewed the server score and want to discard these pending actions.",
  "storageError": "Device storage is unavailable. Keep this screen open and reconnect to save. Download pending actions before leaving.",
  "card": "Final scores",
  "rally": "Rally won",
  "point": "Point won",
  "undo": "Undo",
  "voice": "Voice",
  "pause": "Pause",
  "resume": "Resume",
  "paused": "Match paused",
  "landscape": "Landscape",
  "portrait": "Portrait",
  "rotate": "Rotate your device for a wider courtside view. Device rotation lock may need to be turned off.",
  "swap": "Swap display sides",
  "sets": "Sets",
  "games": "Games",
  "serving": "Serving",
  "boxRequired": "Choose the service box before the next rally.",
  "correct": "Correct / quick entry",
  "preview": "Review score",
  "apply": "Confirm change",
  "cancel": "Cancel",
  "before": "Before",
  "after": "After",
  "reason": "Reason for correction",
  "current": "Current points",
  "awardGame": "Award current game (summary)",
  "summary": "Record completed set/game",
  "historical": "Replace an earlier segment",
  "summaryNote": "Summary entry records the score without inventing rallies. Point statistics are unavailable for summary segments.",
  "discardFollowing": "Discard all later segments and current progress after this segment",
  "segment": "Segment",
  "history": "Recorded actions",
  "summaryOnly": "Summary",
  "rallyHistory": "Rally",
  "confirmResult": "Confirm final result",
  "resultReady": "A winner — ready to confirm?",
  "completed": "Match complete",
  "retired": "Retired",
  "abandoned": "Abandoned",
  "unfinished": "Unfinished",
  "in_progress": "In progress",
  "awaiting_confirmation": "Result awaiting confirmation",
  "winner": "Winner",
  "endEarly": "End match early",
  "retire": "Retire",
  "abandon": "Abandon",
  "finishUnfinished": "Save as unfinished",
  "earlyNote": "This preserves the score without declaring a completed win.",
  "scorecard": "View scorecard",
  "done": "Back to Let’s Play",
  "moment": "Add a moment",
  "share": "Share result",
  "shareNote": "Share only the sport and score. Player names, guests and private media links are excluded.",
  "listen": "Record score",
  "stop": "Stop recording",
  "transcript": "Original transcript",
  "interpret": "Interpret score",
  "voiceReview": "Review voice score",
  "voiceFailure": "Voice is unavailable. You can keep scoring manually or enter the transcript below.",
  "clarify": "More information needed",
  "repair": "Suggested transcription repair",
  "ackRepair": "I acknowledge this transcription repair",
  "staleVoice": "The match or display changed. Interpret again before applying.",
  "deuce": "Deuce",
  "gamePoint": "Game point",
  "matchPoint": "Match point",
  "readOnly": "You can view this match. Only its creator can score.",
  "source": "Rules source",
  "unknown": "Choose explicitly",
  "serverNumber": "Server number",
  "positions": "Right-court player",
  "savedMatches": "Your matches",
  "noMatches": "Your matches will appear here.",
  "tennis": "Tennis",
  "padel": "Padel",
  "pickleball": "Pickleball",
  "squash": "Squash",
  "tennis_one_set": "One set · advantage · tie-break at 6–6",
  "tennis_best_of_three": "Best of 3 sets · advantage · tie-break at 6–6",
  "padel_advantage": "Best of 3 sets · advantage (FIP option 1)",
  "pickleball_one_game": "One game to 11 · side-out · win by 2",
  "pickleball_best_of_three": "Best of 3 to 11 · side-out · win by 2",
  "squash_best_of_three": "Best of 3 to 11 · point-a-rally · win by 2",
  "squash_best_of_five": "Best of 5 to 11 · point-a-rally · win by 2",
  "operation_rally": "Rally won",
  "operation_undo": "Undo",
  "operation_correct_current": "Correct current score",
  "operation_award_game": "Game summary",
  "operation_summary_segment": "Segment summary",
  "operation_replace_segment": "Historical correction; later progress discarded",
  "operation_pause": "Paused",
  "operation_resume": "Resumed",
  "operation_confirm_result": "Result confirmed",
  "operation_service_box": "Service box selected",
  "operation_retire": "Retired",
  "operation_abandon": "Abandoned",
  "operation_unfinished": "Saved unfinished",
  "moreOptions": "More options",
  "backToScores": "Back to scores",
  "pointsForUnfinished": "Only record current points for an unfinished set.",
  "error_completed_segment_has_points": "Current points remain from live scoring. Keep them in a new unfinished set, or explicitly clear them before saving completed sets.",
  "clearStalePoints": "Clear current points",
  "retainUnfinishedPoints": "Keep points in an unfinished set",
  "resultHeading": "One for the history.",
  "sessionWinner": "Session result",
  "playEndedEarly": "Play ended early",
  "runnerUp": "Runner-up",
  "continue": "Continue",
  "backToResult": "Back to result",
  "completionAttention": "Needs attention. Your pending scores are preserved.",
  "savedOnDevice": "Saved on this device · pending sync",
  "serverConfirmed": "Confirmed by server",
  "proposedScore": "Final score",
  "finishNote": "This saves the scores and ends play.",
  "replaceAndFinish": "Replace scores & finish",
  "saveAndFinish": "Save & finish",
  "replaceAndContinue": "Replace scores & continue",
  "levelOnSets": "Level on sets",
  "levelOnGames": "Level on games",
  "reviewChanged": "Scores changed. Cancel this review, compare the latest score and review again.",
  "preparingReview": "Preparing review…",
  "reviewPreparationError": "We couldn’t prepare this voice review. Cancel and review again; your scores are preserved."
}
